import { combineReducers } from "redux";
import authReducer from "./authReducers";
import formReducers from "./formReducers";
import layoutReducers from "./layoutReducers";
import updateReducers from "./updateReducers";

const rootReducer = combineReducers({
  authentication: authReducer,
  formData: formReducers,
  update: updateReducers,
  layout: layoutReducers,
});

export default rootReducer;
